import { render, staticRenderFns } from "./Meals.vue?vue&type=template&id=ad19c6b0&scoped=true"
import script from "./Meals.vue?vue&type=script&lang=js"
export * from "./Meals.vue?vue&type=script&lang=js"
import style0 from "./Meals.vue?vue&type=style&index=0&id=ad19c6b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad19c6b0",
  null
  
)

export default component.exports